export type FormFields = Record<string, string | readonly string[]>;

/** One form entry per value, preserving repeated names for `FormData.getAll`. */
export function formFieldEntries(fields: FormFields): [string, string][] {
  return Object.entries(fields).flatMap(([name, value]) =>
    (typeof value === "string" ? [value] : value).map(
      (entry): [string, string] => [name, entry],
    ),
  );
}
